import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import {
  GetPatientTagListModel,
  UpdateDocumentFolderModel,
  AddImageToFolderModel,
  GetPatientImagesModel,
  GetPatientImagesResultModel,
  CreateDocumentFolderModel,
  GetDocumentFoldersResultModel,
  ReferralPatientImagesModel
} from './models';
import { TdoOrganizerFilterResultModel } from '../../main-interface/organizer/dialogs/tdo-organizer-filter/models/tdo-organizer-filter-result.model';
import { DocumentDataModel } from '../../models/document/document-data.model';
import { DocumentTagDataModel } from '../../models/document/document-tag-data.model';
import { DocumentFolderDataModel } from '../../models/document/document-folder-data.model';
import { DocumentsPerFolderModel } from '../../models/document/documents-per-folder.model';
import { DocumentUploadModel } from '../../models/document/document-upload.model';
import { DocumentResponseModel } from '../../models/document/document-response.model';
import { DocumentGroupCreationModel } from '../../models/document/document-group-creation.model';
import { DocumentGroupDataModel } from '../../models/document/document-group-data.model';
import { DocumentTagResponseModel } from '../../main-interface/controls/tdo-organizer/models/document-tag-response.model';
import { GetDocumentThumbnailModel } from '../../main-interface/controls/tdo-organizer/models/get-document-thumbnail.model';
import { CollageTemplateModel } from '../imaging/image-collage/models/collage-template.model';
// @ts-ignore
import { catchError, tap } from 'rxjs/operators';
import { CollageEmailModel } from '../imaging/image-collage/models/collage-email.model';
import { Globals } from '../../globals';
import { DocumentGroupQueryModel } from '../../models/document/document-group-query.model';
import { DocumentRestoreModel } from '../../models/document/document-restore.model';
import { DocumentInFolderDataModel } from '../../models/document/document-in-folder-data.model';
import { InterceptorSkipHeader } from '../auth/helpers/authinterceptor';
import { DocumentGetCaseTeethModel } from '../../models/document/document-get-case-teeth.model';
import { DocumentSaveCaseTeethModel } from '../../models/document/document-save-case-teeth.model';
import { GetDocumentsIdsModel } from '../../models/document/get-documents-ids.model';
import { AzureBlobStorageService } from '../../services/blob/azure-blob-storage.service';
import { FileHelperService } from '../../services/file-helper.service';
import { BlobModel } from '../../models/blob/blob.model';
import { DocumentFileTypeEnum } from '../../models/enum/document/document-file-type.enum';
import { CaseTooth } from 'src/app/main-interface/imaging/models/CaseTooth';
import { DocumentTypeEnum } from 'src/app/models/enum/document/document-type.enum';

@Injectable({
  providedIn: 'root'
})
export class FileManagerService {
  constructor(private http: HttpClient, private globals: Globals, private azureBlobService: AzureBlobStorageService, private fileHelperService: FileHelperService) {
  }

  patientFolderCache: any = {};
  patientFolderSubscription: any = {};

  documentURLCache: any = {};
  documentURLSubscription: any = {};

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any) => {
      console.error(error);
      return of(result as T);
    };
  }

  getCollage(collageID: string): Observable<CollageTemplateModel> {
    return this.http.get<any>(`/api/document/${collageID}`);
  }

  getCollages(docTypeID: string): Observable<DocumentDataModel> {
    return this.http.get<any>(`api/document`);
  }

  getCollageTemplates(): Observable<CollageTemplateModel[]>  {
    return this.http.get<CollageTemplateModel>('api/collage/get-collage-templates')
      .pipe(catchError(this.handleError<any>('getCollages')));
  }
  //

  saveCollageTemplate(model: CollageTemplateModel): Observable<CollageTemplateModel> {
    return this.http.post<CollageTemplateModel>(`api/collage/save-collage-template`, model);
  }

  sendCollageEmail(model: CollageEmailModel): Observable<CollageEmailModel> {
    return this.http.post<CollageEmailModel>(`api/collage/send-collage-email`, model);
  }

  getDocumentsByFilter(model: TdoOrganizerFilterResultModel) {
    return this.http.post<DocumentDataModel[]>('api/document/get-documents-by-filter', model);
  }


  getPatientTagList(model: GetPatientTagListModel): Observable<DocumentTagResponseModel> {
    return this.http.post<DocumentTagResponseModel>(`/api/document/get-patient-tag-list`, model)
      .pipe(
        tap(_ => {
          /*for (const t of _.patient) {
            for (const te of t.patientTeeth) {
              te.
            }
          }*/
        })
      );
  }

  handledReferralPatientImages(model: ReferralPatientImagesModel): Observable<boolean> {
    return this.http.post<boolean>('/api/document/handle-referral-patient-images', model);
  }

  getDocumentThumbnails(model: GetDocumentThumbnailModel): Observable<DocumentInFolderDataModel[]> {
    return this.http.post<DocumentInFolderDataModel[]>(`/api/document/get-document-thumbnails`, model);
  }

  getDocumentThumbnailsClaimAttachments(model: GetDocumentThumbnailModel): Observable<DocumentDataModel[]> {
    return this.http.post<DocumentDataModel[]>(`/api/document/get-document-thumbnails-claim-attachments`, model);
  }

  getTeeth(models: DocumentInFolderDataModel[]): Observable<DocumentInFolderDataModel[]> {
    return this.http.post<DocumentInFolderDataModel[]>(`/api/document/get-teeth/${this.globals.currentToothNumberingId}`, models);
  }

  getPatientImages(model: GetPatientImagesModel): Observable<GetPatientImagesResultModel> {
    return this.http.post<GetPatientImagesResultModel>(`/api/document/getPatientImages`, model);
  }

  getLibraryDocumentFolders(): Observable<GetDocumentFoldersResultModel> {
    return this.http.get<GetDocumentFoldersResultModel>(`/api/document/get-document-folders`);
  }

  getLibraryDocumentFoldersPresentation(FolderId: string): Observable<DocumentFolderDataModel[]> {
    return this.http.get<DocumentFolderDataModel[]>(`/api/document/get-document-foldersPresentation/${FolderId}`);
  }

  // TODO: remove once new organizer is completed
  getDocumentFolders(patientID: string): Observable<GetDocumentFoldersResultModel> {
    return this.http.get<GetDocumentFoldersResultModel>(`/api/document/getDocumentFolders/${patientID}`);
  }

  addDocumentFolder(model: DocumentFolderDataModel): Observable<DocumentFolderDataModel> {
    return this.http.post<DocumentFolderDataModel>('/api/document/add-document-folder', model);
  }

  // Possibly deprecate in favor of addDocumentFolder
  createDocumentFolder(model: CreateDocumentFolderModel): Observable<string> {
    return this.http.post<string>(`/api/document/createDocumentFolder`, model);
  }

  deleteDocumentFolder(documentFolderID: string): Observable<any> {
    return this.http.delete<any>(`/api/document/delete-document-folder/${documentFolderID}`);
  }

  updateDocumentFolder(model: UpdateDocumentFolderModel): Observable<any> {
    return this.http.put<any>(`/api/document/updateDocumentFolder`, model);
  }

  addDocumentsToFolder(addModel: DocumentsPerFolderModel): Observable<any> {
    return this.http.post<any>('api/document/add-documents-to-folder', addModel);
  }

  removeDocumentsFromFolder(removeModel: DocumentsPerFolderModel): Observable<any> {
    return this.http.post<any>('api/document/remove-documents-from-folder', removeModel);
  }

  addImageToFolder(model: AddImageToFolderModel): Observable<string> {
    return this.http.post<string>(`/api/document/addImageToFolder`, model);
  }

  addDocumentTags(documentId: string, enumTagIDs: string[]): Observable<any> {
    return this.http.post<any>(`/api/document/add-document-tags/${documentId}`, enumTagIDs);
  }

  // Case work item id is only added to check if its already associated to a group relative to the selected case (Not always used)
  addMultiDocumentsTags(docIds: string[], tagEnums: string[], patientCaseId = null, patientId = null): Observable<DocumentTagDataModel[]> {
    return this.http.post<DocumentTagDataModel[]>(`/api/document/add-multi-documents-tags`, {docIds, tagEnums, patientCaseId, patientId});
  }

  removeDocumentTags(documentId: string, dataDocumentTagIds: string[] = [], enumDocumentTagIds: string[] = []): Observable<any> {
    return this.http.post<any>(`/api/document/remove-document-tags/${documentId}`, {documentTagIDs: dataDocumentTagIds, enumDocumentTagIds});
  }

  // TODO: uploadDocument and uploadDocuments should be one function.  If only one document, then simply an array with 1 item.
  // This is being used from file-camera-upload.component.ts currently.
  uploadDocumentsOld(document, patientId) {
    const formData = new FormData();
    formData.append('PatientId', patientId);
    formData.append('file', document);

    const httpOptions = {
      headers: new HttpHeaders({})
    };
    return this.http.post<any>('/api/document/uploadDocuments', formData, httpOptions);
  }

  // blobXml: this.xmlfile, blob: ImageUtilities.base64ToBlob(this.blob, 'image/jpeg'),
  // blobThumbnail: ImageUtilities.base64ToBlob(blobThumbnail, 'image/jpeg'), docClassId: this.enumDocumentClassTypeIdOriginal,
  // docFileTypeId: this.enumDocumentFileTypeIdJPG, docTags: this.imageCategories, hasAnnotation: this.hasAnnotation });
  uploadDocuments(models: DocumentUploadModel[]) {
    return new Observable<DocumentResponseModel>((obs) => {

      this.getDocumentsIds(models.length).subscribe((documentIds) => {
        const returnedDocs: DocumentDataModel[] = [];
        const blobs: BlobModel[] = [];
        let isReadyForNext = true;
        let i = 0;
        const ivl = setInterval(() => {
          if (isReadyForNext) {
            isReadyForNext = false;
            const uploadModel = models[i];
            const idModel = documentIds[i];
            let amountToUpload = 0;
            this.fileHelperService.getDataAndThumbnailFromFile(uploadModel.blob as File).subscribe((res) => {
              switch (res.fileMimeType) {
                case FileHelperService.MIME_JPG:
                case FileHelperService.MIME_PNG:
                  uploadModel.docFileTypeId = DocumentFileTypeEnum.JPG;
                  break;
                case FileHelperService.MIME_AVI:
                  uploadModel.docFileTypeId = DocumentFileTypeEnum.AVI;
                  break;
                case FileHelperService.MIME_MOV:
                  uploadModel.docFileTypeId = DocumentFileTypeEnum.MP4;
                  break;
                case FileHelperService.MIME_MP4:
                  uploadModel.docFileTypeId = DocumentFileTypeEnum.MP4;
                  break;
                case FileHelperService.MIME_PDF:
                  uploadModel.docFileTypeId = DocumentFileTypeEnum.PDF;
                  break;
                case FileHelperService.MIME_MP3:
                  uploadModel.docFileTypeId = DocumentFileTypeEnum.MP3;
                  break;
                case FileHelperService.MIME_WAV:
                  uploadModel.docFileTypeId = DocumentFileTypeEnum.WAV;
                  break;
                case FileHelperService.MIME_POWERPOINT_PPTX:
                  uploadModel.docFileTypeId = DocumentFileTypeEnum.PowerPoint;
                  break;
                case FileHelperService.MIME_EXCEL_XLXS:
                  uploadModel.docFileTypeId = DocumentFileTypeEnum.Excel;
                  break;
                case FileHelperService.MIME_APPLICATION_XML:
                case FileHelperService.MIME_TEXT_XML:
                  uploadModel.docFileTypeId = DocumentFileTypeEnum.XML;
                  break;
                case FileHelperService.MIME_JSON:
                  uploadModel.docFileTypeId = DocumentFileTypeEnum.JSON;
                  break;
              }

              const blobModel = new BlobModel();
              blobModel.content = res.fileDataBlob;
              blobModel.name = idModel.original + '.' + res.originalExtension;
              if (uploadModel.patientId) {
                blobModel.patientId = uploadModel.patientId;
              }
              idModel.originalName = blobModel.name;
              blobs.push(blobModel);
              amountToUpload += blobModel.content.size;

              const blobThumbnail = new BlobModel();
              blobThumbnail.content = res.thumbnailDataBlob;
              blobThumbnail.name = idModel.thumbnail + '.' + res.thumbnailExtension;
              if (uploadModel.patientId) {
                blobThumbnail.patientId = uploadModel.patientId;
              }
              idModel.thumbnailName = blobThumbnail.name;
              blobs.push(blobThumbnail);

              if (uploadModel.blobXml) {
                const blobAnnotation = new BlobModel();
                blobAnnotation.content = uploadModel.blobXml;
                blobAnnotation.name = idModel.xml + '.xml';
                if (uploadModel.patientId) {
                  blobAnnotation.patientId = uploadModel.patientId;
                }
                idModel.xmlName = blobAnnotation.name;
                blobs.push(blobAnnotation);
              }

              uploadModel.BlobInfo = idModel;

              if (i === models.length - 1) {
                clearInterval(ivl);
                this.azureBlobService.uploadBlobs(blobs, (isSuccess) => {
                  if (isSuccess) {
                    const responseDocs: DocumentInFolderDataModel[] = [];

                    let j = 0;
                    let h = 0;
                    for (const model of models) {
                      const formData = new FormData();
                      formData.append('PatientId', model.patientId);
                      if (model.BlobInfo) {
                        const docIdModel = documentIds[h];
                        formData.append('BlobInfo', JSON.stringify(docIdModel));
                        h++;
                      }

                      if (model.duplicateDocId != null) {
                        formData.append('duplicateDocId', model.duplicateDocId);
                      }

                      if (model.patientCaseId != null) {
                        formData.append('PatientCaseId', model.patientCaseId);
                      }
                      if (model.parentDocId != null) {
                        formData.append('ParentDocumentID', model.parentDocId);
                      }
                      if (model.folderId) {
                        formData.append('folderToUploadID', model.folderId);
                      }

                      formData.append('DocumentOrder', model.documentOrder.toString());

                      if (model.thumbDocId != null) {
                        formData.append('ThumbnailDocumentID', model.thumbDocId);
                      }
                      formData.append('isSaveAsNew', String(model.isSaveAsNew));
                      if (model.docTagIds) {
                        formData.append('enumDocumentTags', model.docTagIds.toString());
                      }
                      formData.append('enumDocumentClassID', model.docClassId);
                      formData.append('enumDocumentFileTypeID', model.docFileTypeId);
                      formData.append('enumDocumentTypeID', model.docTypeId);
                      formData.append('hasAnnotation', String(model.hasAnnotation));
                      formData.append('LOCID', this.globals.LOCID);
                      if (model.caseWorkItemToothIds != null) {
                        formData.append('caseWorkItemToothIds', model.caseWorkItemToothIds.toString());
                      }
                      if (model.caseWorkItemId != null) {
                        formData.append('CaseWorkItemId', model.caseWorkItemId.toString());
                      }
                      if (model.deviceId != null) {
                        formData.append('DeviceId', model.deviceId.toString());
                      }
                      if (model.createDate != null) {
                        formData.append('createDate', model.createDate);
                      }
                      if (model.description != null) {
                        formData.append('Description', model.description);
                      }
                      this.http.post<DocumentResponseModel>('/api/document/uploadDocumentV2', formData).subscribe((docRes) => {
                        j++;
                        // Change this once we use a system that handles multiple document registrations at once
                        returnedDocs.push(docRes.documents[0]);
                        if (j === models.length) {
                          docRes.documents = returnedDocs;
                          obs.next(docRes);
                          obs.complete();
                        }
                      }, err => {
                        obs.error(err);
                      });
                    }
                  } else {
                    obs.error();
                    obs.complete();
                  }
                });
              }
              i++;
              isReadyForNext = true;
            });
          }
        }, 100);
      });
    });
  }

  getDocumentsIds(num: number) {
    return this.http.get<GetDocumentsIdsModel[]>(`api/document/getDocumentsIds/${num}`);
  }

  uploadDocumentV2(model: DocumentUploadModel) {
    const formData = new FormData();
    formData.append('PatientId', model.patientId);
    if (model.BlobInfo) {
      formData.append('BlobInfo', JSON.stringify(model.BlobInfo));
    }

    if (model.patientCaseId != null) {
      formData.append('PatientCaseId', model.patientCaseId);
    }
    if (model.parentDocId != null) {
      formData.append('ParentDocumentID', model.parentDocId);
    }
    if (model.folderId) {
      formData.append('folderToUploadID', model.folderId);
    }

    formData.append('DocumentOrder', model.documentOrder.toString());

    if (model.thumbDocId != null) {
      formData.append('ThumbnailDocumentID', model.thumbDocId);
    }
    formData.append('isSaveAsNew', String(model.isSaveAsNew));
    if (model.docTagIds) {
      formData.append('enumDocumentTags', model.docTagIds.toString());
    }
    formData.append('enumDocumentClassID', model.docClassId);
    formData.append('enumDocumentFileTypeID', model.docFileTypeId);
    formData.append('enumDocumentTypeID', model.docTypeId);
    formData.append('hasAnnotation', String(model.hasAnnotation));
    formData.append('LOCID', this.globals.LOCID);
    if (model.caseWorkItemToothIds != null) {
      formData.append('caseWorkItemToothIds', model.caseWorkItemToothIds.toString());
    }
    if (model.caseWorkItemId != null) {
      formData.append('CaseWorkItemId', model.caseWorkItemId.toString());
    }
    if (model.createDate != null) {
      formData.append('createDate', model.createDate);
    }
    return this.http.post<DocumentResponseModel>('/api/document/uploadDocumentV2', formData);
  }

  // TODO: Legacy from old draw component.  Deprecate
  uploadDocumentFromDraw(document, documentThumbnail, patientId, currentPatientCaseID, documentTags, docClassId,
    docFileTypeId, parentDocId,  hasAnnotation) {
    const formData = new FormData();
    formData.append('PatientId', patientId);
    formData.append('file', document);
    formData.append('fileThumbnail', documentThumbnail);
    if (currentPatientCaseID != null) {
      formData.append('PatientCaseId', currentPatientCaseID);
    }
    if (parentDocId != null) {
      formData.append('ParentDocumentID', parentDocId);
    }
    formData.append('enumDocumentTags', documentTags);
    formData.append('enumDocumentClassID', docClassId);
    formData.append('enumDocumentFileTypeID', docFileTypeId);
    formData.append('enumDocumentTypeID', DocumentTypeEnum.Scan);
    formData.append('hasAnnotation', hasAnnotation);

    const httpOptions = {
      headers: new HttpHeaders({})
    };
    return this.http.post<any>('/api/document/uploadDocument', formData, httpOptions);
  }


  createDocumentGroup(creationObj: DocumentGroupCreationModel): Observable<any> {
    return this.http.post<any>(`/api/document/create-document-group`, creationObj);
  }

  updateDocumentGroup(creationObj: DocumentGroupCreationModel): Observable<any> {
    return this.http.put<any>(`/api/document/group`, creationObj);
  }

  deleteDocumentGroupsByObjectIds(documentId: string, groupIds: string[]) {
    return this.http.post<void>(`api/document/delete-document-groups-by-objectids/${documentId}`, groupIds);
  }

  getGroupsForDocument(model: DocumentGroupQueryModel): Observable<DocumentGroupDataModel[]> {
    return this.http.post<DocumentGroupDataModel[]>(`/api/document/get-document-groups`, model);
  }

  getTeethByDocumentId(DocumentId: string): Observable<CaseTooth[]> {
    return this.http.get<CaseTooth[]>(`/api/document/getTeethByDocumentId/${DocumentId}`);
  }

  getDocumentGroup(documentGroupID: string): Observable<any> {
    return this.http.get<any>(`/api/document/getDocumentGroup/${documentGroupID}`);
  }

  getDocumentGroupByObjectId(patientId: string, objectId: string): Observable<DocumentGroupDataModel[]> {
    return this.http.get<DocumentGroupDataModel[]>(`/api/document/getDocumentGroupByObjectId/${patientId}/${objectId}`);
  }

  getDocumentTagOptions(): Observable<any> {
    return this.http.get<any>('/api/document/getDocumentTagOptions');
  }

  getDocument(documentId: string): Observable<DocumentDataModel> {
    return this.http.get<any>(`/api/document/getDocument/${documentId}`);
  }
  getDocumentAnnotation(physicalFilename: string, patientId: string): Observable<DocumentDataModel> {
    return this.http.get<any>(`/api/document/getDocumentAnnotation/${physicalFilename}/${patientId}`);
  }

  getDocumentTags(documentId: string): Observable<any> {
    return this.http.get<any>(`/api/document/getDocumentTags/${documentId}`);
  }

  getPatientFolderPromise(PatientId: string) {
    // tslint:disable-next-line:no-shadowed-variable
    const promise = new Promise((resolve, reject) => {
      const now = new Date().getTime();
      const cacheTime = 1000 * 15;

      if (this.patientFolderCache[PatientId] && ((now - this.patientFolderCache[PatientId].timeStamp) < cacheTime)) {
        resolve(JSON.parse(JSON.stringify(this.patientFolderCache[PatientId].data)));
      } else {
        if (this.patientFolderSubscription[PatientId]) {
          const interval = setInterval(_ => {
            if (!this.patientFolderSubscription[PatientId]) {
              resolve(JSON.parse(JSON.stringify(this.patientFolderCache[PatientId].data)));
              clearInterval(interval);
            }
          }, 200);
        } else {
          this.patientFolderSubscription[PatientId] = true;
          this.getPatientFolder(PatientId)
            .subscribe(response => {

              const timeStamp = new Date().getTime();
              this.patientFolderCache[PatientId] = { data: response, timeStamp };
              this.patientFolderSubscription[PatientId] = false;
              resolve(JSON.parse(JSON.stringify(this.patientFolderCache[PatientId].data)));
            }, err => {
              this.patientFolderSubscription[PatientId] = false;
              reject(err);
            });
        }
      }
    });
    return promise;
  }

  getPatientFolder(PatientId: string): Observable<any> {
    return this.http.get<any>(`/api/document/getPatientFolder/${PatientId}`);
  }

  getDocumentGroupsForPatient(PatientId: string): Observable<any> {
    return this.http.get<any>(`/api/document/getDocumentGroupsForPatient/${PatientId}`);
  }

  getDocumentURLPromise(documentId: string) {

    // tslint:disable-next-line:no-shadowed-variable
    const promise = new Promise<string>((resolve, reject) => {

      const now = new Date().getTime();
      const cacheTime = 1000 * 60 * 60;

      if (this.documentURLCache[documentId] && ((now - this.documentURLCache[documentId].timeStamp) < cacheTime)) {
        resolve(JSON.parse(JSON.stringify(this.documentURLCache[documentId].data)));
      } else {
        if (this.documentURLSubscription[documentId]) {
          const interval = setInterval(_ => {
            if (!this.documentURLSubscription[documentId]) {
              resolve(JSON.parse(JSON.stringify(this.documentURLCache[documentId].data)));
              clearInterval(interval);
            }
          }, 200);
        } else {
          this.documentURLSubscription[documentId] = true;
          this.getDocumentURL(documentId)
            .subscribe(response => {
              const timeStamp = new Date().getTime();

              this.documentURLCache[documentId] = { data: response, timeStamp };

              this.documentURLSubscription[documentId] = false;
              resolve(JSON.parse(JSON.stringify(this.documentURLCache[documentId].data)));
            }, err => {
              this.documentURLSubscription[documentId] = false;
              reject(err);
            });
        }
      }
    });
    return promise;
  }

  getDocumentURL(documentId: string): Observable<any> {
    return this.http.get<any>(`/api/document/getDocumentURL/${documentId}`);
  }

  // Deletes the documents outright, rather then specifying from what folder (possibly remove)
  markDocumentsAsDeleted(documentIDs: string[]): Observable<any> {
    return this.http.post<any>(`/api/document/markDocumentsAsDeleted`, documentIDs);
  }

  // Deletes the documents outright, rather then specifying from what folder (possibly remove)
  markDocumentAsDeleted(documentId: string): Observable<any> {
    return this.http.post<any>(`/api/document/markDocumentAsDeleted/${documentId}`, {});
  }

  createPatientFolderStructure(PatientId: string): Observable<any> {
    return this.http.post<any>(`/api/document/createPatientFolderStructure/${PatientId}`, {});
  }

  getFileList(): Observable<any> {
    return this.http.get<any>('/api/general/getFileList');
  }

  getFileByName(fileObj: any): Observable<any> {
    return this.http.post<any>('/api/general/downloadFile', fileObj);
  }

  uploadFile(fileToUpload: File): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('filekey', fileToUpload, fileToUpload.name);

    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');

    const httpOptions = {
      headers
    };

    return this.http.post('/api/general/uploadFile', formData, httpOptions);
  }

  // Tags
  deleteDocumentTag(tag: DocumentTagDataModel) {
    return this.http.post<any>('/api/document/delete-document-tag', tag);
  }

  getDocumentUrlFromDocument(mod: DocumentDataModel): string {
    if (!mod) {
      return;
    }

      if (mod.PatientId) {
        return "/api/fs/patient/" + mod.PatientId + "/" + mod.DocumentFileName;
       } else {
        return "/api/fs/other/" + mod.DocumentFileName;
      }
  }

  getDocumentImageUrl(patientId: string, documentFileName: string) {
    return "/api/fs/patient/" + patientId + "/" + documentFileName;

  }

  getCollageUrl(patientId: string, documentFileName: string): string {
    if (patientId) {
      return "/api/fs/patient/" + patientId + "/" + documentFileName;
    } else {
      return "/api/fs/other/" + documentFileName;
    }

  }

  getPatientDocumentUrl(patientId: string, filename: string) {
    return "/api/fs/patient/" + patientId + "/" + filename;
  }

  getDocuments(docs: string[]) {
    if (docs.length === 0)
      return of([]);
    else
      return this.http.post<DocumentDataModel[]>('/api/document/get-documents', docs);
  }

  getPatientPicture(currentPatient: string) {
    return this.http.get<DocumentDataModel>(`/api/document/get-patient-picture/${currentPatient}`);
  }
  getPatientPictureClearCache(currentPatient: string) {
    return this.http.get<DocumentDataModel>(`/api/document/get-patient-picture-clear-cache/${currentPatient}`);
  }

  getCaseIdFormsRepo(currentPatient: string) {
    return this.http.get<any>(`/api/document/get-case-id-forms-repo/${currentPatient}`);
  }

  restoreDeletedItems(model: DocumentRestoreModel) {
    return this.http.post<void>('/api/document/restore-documents', model);
  }

  updateDocumentsOrder(thumbs: DocumentInFolderDataModel[]) {
    return this.http.post<void>('/api/document/update-order', thumbs);
  }

  getThumbnailsByParentDocumentIds(docIds: string[]) {
    return this.http.post<DocumentDataModel[]>(`/api/document/get-thumbnails-by-parent-document-ids`, docIds);
  }

  getPrePostOpForLanding(patientId: string, objectId: string) {
    //return this.http.get<DocumentDataModel[]>(`api/document/get-pre-post-op-for-landing/${patientId}/${objectId}`);
    return this.http.get<any>(`api/document/get-pre-post-op-for-landing/${patientId}/${objectId}`);
  }

  downloadFileData(url: string) {
    return this.http.get(url, { responseType: 'blob', headers: new HttpHeaders().set(InterceptorSkipHeader, '') });
  }

  getCaseTeethForDocument(dataDocument: DocumentDataModel): Observable<DocumentGetCaseTeethModel> {
    return this.http.post<DocumentGetCaseTeethModel>('api/document/get-case-teeth-for-document', { DocumentID: dataDocument.DocumentID, ParentDocumentID: dataDocument.ParentDocumentID });
  }

  saveCaseTooth(model: DocumentSaveCaseTeethModel): Observable<void> {
    return this.http.post<void>(`api/document/save-case-teeth-for-document`, model);
  }

  getDocumentsByTagsAndGroup(categoryEnumIds: string[], objectId: string) {
    const obj = { categories: categoryEnumIds, objectId };
    return this.http.post<DocumentDataModel[]>(`api/document/get-documents-by-tags-and-group`, obj);
  }
  updateImageDate(imgDate: string, documentIds: string[]): Observable<any> {
    return this.http.post<any>(`/api/document/updateImageDate/${imgDate}`, documentIds);
  }

  getInsuranceDocuments(patientID: string, paymentID: string): Observable<any> {
    return this.http.get<any>(`/api/documents/insurance/${patientID}/${paymentID}`)
  }

}
